import { backgroundColorNormal } from './palette';

export const modalBackgroundColor = backgroundColorNormal;
